// Utility function for smooth scroll to top
export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

// Utility function to check if current path matches target path
export const shouldScrollToTop = (currentPath, targetPath) => {
  return currentPath === targetPath;
};

// Enhanced scroll function that only scrolls if on the same page
export const scrollToTopIfSamePage = (currentPath, targetPath) => {
  if (shouldScrollToTop(currentPath, targetPath)) {
    scrollToTop();
  }
};
